import { t } from 'i18next';
import { Dispatch, SetStateAction } from 'react';

import { Modal, Visible } from 'coreOld/components';
import { Size } from 'coreOld/enums';
import { ImportType } from 'corporate/enums';
import CostManufacturerModal from 'partsOld/components/CostManufacturerModal';
import ImportModal from 'partsOld/components/ImportModal';
import { DragAndDropProvider } from 'partsOld/components/ImportModal/dragAndDrop';
import UploadFile from 'partsOld/components/UploadFile';
import { ModalStep } from 'partsOld/enums';

import { Subtitle, Wrapper } from './importStyle';

interface IProps {
  onSubmit: (obj) => void;
  step: ModalStep;
  setStep: Dispatch<SetStateAction<ModalStep>>;
  importType: ImportType;
  setImportType: Dispatch<SetStateAction<ImportType>>;
  data;
}

const getTitle = (step) => {
  if (step === ModalStep.PREVIEW_ROWS) {
    return t('titlePreviewImport');
  }

  return t('titleFileUploaded');
};

const getSubtitle = (step) => {
  if (step === ModalStep.COLUMNS_HEADERS) {
    return t('messageDragAndDropColumnHeader');
  }

  if (step === ModalStep.COST_MANUFACTURER) {
    return t('messageSingleManufacturerImport');
  }

  return '';
};

const ImportView = ({ onSubmit, setStep, step, data, importType, setImportType }: IProps) => {
  return (
    <Wrapper>
      <UploadFile onSubmit={onSubmit} setStep={setStep} setImportType={setImportType} />

      <Modal
        title={getTitle(step)}
        subtitle={<Subtitle>{getSubtitle(step)}</Subtitle>}
        isOpen={Boolean(step)}
        onClose={() => setStep(null)}
        size={step === ModalStep.COST_MANUFACTURER ? Size.LG : Size.FULL_WIDTH}
      >
        <Visible when={step === ModalStep.COST_MANUFACTURER}>
          <CostManufacturerModal onSubmit={onSubmit} setStep={setStep} />
        </Visible>

        <Visible when={step === ModalStep.COLUMNS_HEADERS || step === ModalStep.PREVIEW_ROWS}>
          <DragAndDropProvider>
            <ImportModal
              fileId={data?.fileId}
              step={step}
              setStep={setStep}
              data={data}
              onSubmit={onSubmit}
              importType={importType}
            />
          </DragAndDropProvider>
        </Visible>
      </Modal>
    </Wrapper>
  );
};

export default ImportView;
